<template>
  <div id="main-reporte-estimaciones-relacion-conceptos">
    <div
      class="text-uppercase mb-5">
      <v-row
        align="center">
        <v-col
          cols="4">
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              CONTRATO:
            </v-col>
            <v-col
              cols="6">
              {{ contrato.numero }}
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              CONTRATISTA:
            </v-col>
            <v-col
              cols="6">
              {{ contrato.contratista.nombreRazonSocial }}
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="4">
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              FORMULADA EL:
            </v-col>
            <v-col
              cols="6">
              {{ estimacion.fechaAutorizacion }}
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              PERIODO DEL:
            </v-col>
            <v-col
              cols="6">
              {{ new Date(`${estimacion.fechaDel} 00:00:0`)
                .toLocaleDateString('es-MX', { year: 'numeric',
                    month: 'long', day: 'numeric' }) }}
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="4">
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              ESTIMACIÓN NO.
            </v-col>
            <v-col
              cols="6">
              <v-chip
                color="base4">
                {{ estimacion.numero }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              AL:
            </v-col>
            <v-col
              cols="6">
              {{ new Date(`${estimacion.fechaAl} 00:00:0`)
                .toLocaleDateString('es-MX', { year: 'numeric',
                    month: 'long', day: 'numeric' }) }}
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="6">
          <v-row
            no-gutters>
            <v-col>
              <span class="font-weight-bold text-uppercase">
                Fecha presentación
              </span>
            </v-col>
            <v-col>
              {{ new Date(`${estimacion.fechaPresentacion} 00:00:0`).toLocaleDateString() }}
            </v-col>
            <v-col>
              <span class="font-weight-bold text-uppercase">
                Fecha autorización
              </span>
            </v-col>
            <v-col>
              {{ new Date(`${estimacion.fechaAutorizacion} 00:00:0`).toLocaleDateString() }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-simple-table
        class="imprimir-tabla">
        <template
          v-slot:default>
          <thead>
            <tr
              class="base4">
              <th class="text-center" colspan="6">CONTRATO</th>
              <th class="text-center" colspan="2">ESTIMACION ANTERIOR</th>
              <th class="text-center" colspan="2">ESTIMACION No {{ estimacion.numero }}</th>
              <th class="text-center" colspan="3">ACUMULADO</th>
            </tr>
            <tr
              class="base5">
              <th class="text-center">CLAVE</th>
              <th></th>
              <th>CONCEPTO</th>
              <th>UNIDAD</th>
              <th>CANTIDAD</th>
              <th>P. UNITARIO</th>
              <th class="text-center"
                style="border-left: thin solid rgba(0, 0, 0, 0.12);">
                CANTIDAD
              </th>
              <th class="text-center"
                style="border-right: thin solid rgba(0, 0, 0, 0.12);">
                IMPORTE
              </th>
              <th class="text-center">
                CANTIDAD
              </th>
              <th class="text-center"
                style="border-right: thin solid rgba(0, 0, 0, 0.12);">
                IMPORTE
              </th>
              <th class="text-center">SUBTOTAL</th>
              <th class="text-center">P. UNITARIO</th>
              <th class="text-center">TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(partida, index) in getPartidas">
              <template
                v-if="partida.padre && partida.padre.tipo === 0">
                <tr
                  :key="`padre-${partida.padre.id}-${index}`"
                  class="base4">
                  <td
                    class="text-center">
                    {{ partida.padre.clave }}
                  </td>
                  <td></td>
                  <td colspan="12">
                    {{ partida.padre.concepto }}
                  </td>
                </tr>
              </template>
              <template>
                <tr
                  :key="partida.id"
                  class="base4">
                  <td
                    class="text-center">
                    {{ partida.clave }}
                  </td>
                  <td>
                    <template
                      v-if="partida.padre">
                      <span
                        class="font-weight-bold">
                        {{ partida.padre.clave }}
                      </span>
                    </template>
                  </td>
                  <td colspan="12">
                    {{ partida.concepto }}
                  </td>
                </tr>
              </template>

              <!-- Conceptos -->
              <template
                v-for="{
                  concepto,
                  importe,
                  cantidad,
                  cantidadEstimadaAnterior,
                  importeEstimadoAnterior} in partida.conceptosEstimados">
                  <template>
                    <tr
                      :key="concepto.id">
                      <td
                        class="text-center">
                        {{ concepto.clave }}
                      </td>
                      <td>
                        <template
                          v-if="partida.padre">
                          <span
                            class="font-weight-bold">
                            {{ concepto.padre.clave }}
                          </span>
                        </template>
                      </td>
                      <td>
                        {{ concepto.concepto }}
                      </td>
                      <td>
                        {{ concepto.unidad }}
                      </td>
                      <td>
                        {{ concepto.cantidad }}
                      </td>
                      <td
                        class="text-right">
                        {{ concepto.precioUnitario | currency }}
                      </td>
                      <td style="border-left: thin solid rgba(0, 0, 0, 0.12);">
                        {{ cantidadEstimadaAnterior }}
                      </td>
                      <td
                        class="text-right"
                        style="border-right: thin solid rgba(0, 0, 0, 0.12);">
                        {{ importeEstimadoAnterior | currency }}
                      </td>
                      <td>
                        {{ cantidad }}
                      </td>
                      <td
                        class="text-right"
                        style="border-right: thin solid rgba(0, 0, 0, 0.12);">
                        {{ importe | currency }}
                      </td>
                      <td>
                        {{ (cantidadEstimadaAnterior + cantidad) }}
                      </td>
                      <td
                        class="text-right">
                        {{ concepto.precioUnitario | currency }}
                      </td>
                      <td
                        class="text-right">
                        {{ (importe + importeEstimadoAnterior) | currency }}
                      </td>
                    </tr>
                  </template>
              </template>
              <!-- Sumatorias -->
              <template>
                <tr
                  :key="`sumatoria-${partida.id}`"
                  class="font-weight-bold base5">
                  <td
                    colspan="6" class="text-right">
                    SUBTOTAL {{ partida.concepto }}
                  </td>
                  <td>
                  </td>
                  <td
                    class="text-right">
                    {{ $ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior')
                    | currency }}
                  </td>
                  <td></td>
                  <td
                    class="text-right">
                    {{ $ObjSumar(partida.conceptosEstimados, 'importe') | currency }}
                  </td>
                  <td></td>
                  <td></td>
                  <td class="text-right">
                    {{ ($ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior')
                    + $ObjSumar(partida.conceptosEstimados, 'importe')) |currency }}
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
          <tfoot
            class="text-right font-weight-bold">
            <tr>
              <td colspan="6">
                {{contrato.esObraFinanciada ? 'IMPORTE COSTO DIRECTO' : 'IMPORTE ESTIMADO'}}
              </td>
              <td></td>
              <td>
                {{ sumaTotalEstimadoAnteriror.importe | currency }}
              </td>
              <td></td>
              <td>
                {{ sumaTotalEstimadoActual.importe | currency }}
              </td>
              <td></td>
              <td></td>
              <td>
                {{ (sumaTotalEstimadoAnteriror.importe
                + sumaTotalEstimadoActual.importe) | currency }}
              </td>
            </tr>
            <!-- <tr>
              <td colspan="5">I.V.A.</td>
              <td>
                {{ sumaTotalContratado.iva | currency }}
              </td>
              <td></td>
              <td>
                {{ sumaTotalEstimadoAnteriror.iva | currency }}
              </td>
              <td></td>
              <td>
                {{ sumaTotalEstimadoActual.iva | currency }}
              </td>
              <td></td>
              <td></td>
              <td>{{ (sumaTotalContratado.iva
                + sumaTotalEstimadoAnteriror.iva
                + sumaTotalEstimadoActual.iva) | currency }}</td>
            </tr>
            <tr>
              <td colspan="5">TOTAL</td>
              <td>
                {{ sumaTotalContratado.total | currency }}
              </td>
              <td></td>
              <td>
                {{ sumaTotalEstimadoAnteriror.total | currency }}
              </td>
              <td></td>
              <td>
                {{ sumaTotalEstimadoActual.total | currency }}
              </td>
              <td></td>
              <td></td>
              <td>
                {{ (sumaTotalContratado.total
                + sumaTotalEstimadoAnteriror.total
                + sumaTotalEstimadoActual.total) | currency }}
              </td>
            </tr> -->
          </tfoot>
        </template>
      </v-simple-table>
    </div>
    <div id="firmas-reporte-relacion-conceptos">
      <v-row
        class="mt-5"
        justify="space-between">
        <v-col
          cols="3">
          <firma
            :nombre="contrato.contratista.nombreRepresentante"
            :sub-nombre="contrato.contratista.nombreRazonSocial">
          </firma>
        </v-col>
        <v-col
          v-if="getContratoSupervisionExterna"
          cols="3">
          <firma
            :nombre="getContratoSupervisionExterna
            .contratoRelacionado.contratista.nombreRazonSocial"
            sub-nombre="Supervisión externa"
            key="supervisionExterna">
          </firma>
        </v-col>
        <v-col
          cols="3">
          <firma
            v-if="getSupervisor"
            :nombre="getSupervisor.funcionario.nombre"
            sub-nombre="supervisor de obra"
            key="contratista">
          </firma>
        </v-col>
        <template
          v-for="firma in firmas">
          <template>
            <v-col
              cols="3"
              :key="firma.id">
              <firma
                :nombre="firma.funcionario.nombre"
                :sub-nombre="firma.funcionario.puesto">
              </firma>
            </v-col>
          </template>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import Firma from '@/components/Firma.vue';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';
import mixDescargaRelacionConceptos from './mixDescargaRelacionConceptos';

export default {
  name: 'MainReporteEstimacionesRelacionConceptos',
  components: {
    Firma,
  },
  mixins: [mixGenerarPdf,
    mixFormatoEstructura,
    mixDescargaRelacionConceptos],
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {};
  },
  /*
  methods: {
    sumaImporteContratado(estimado) {
      const importes = estimado.map((est) => ({
        importe: est.concepto.importe,
      }));
      return this.$ObjSumar(importes, 'importe');
    },
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdf() {
      this.$emit('generando');
      let contrato = {
        numero: this.contrato.numero,
        objeto: this.contrato.meta,
        contratista: this.contrato.contratista,
        fecha: this.contrato.fecha,
        fechaInicio: this.contrato.fechaInicio,
        fechaTermino: this.contrato.fechaTermino,
        importe: this.contrato.importe,
      };
      let estimacion = {
        numero: this.estimacion.numero,
        fechaDel: this.estimacion.fechaDel,
        fechaAl: this.estimacion.fechaAl,
        fechaPresentacion: this.estimacion.fechaPresentacion,
        fechaAutorizacion: this.estimacion.fechaAutorizacion,

      };
      const tituloTotales =
      this.contrato.esObraFinanciada ? 'IMPORTE COSTO DIRECTO' : 'IMPORTE ESTIMADO';
      let totales = {
        tituloTotales,
        sumaTotalContratado: this.sumaTotalContratado.importe,
        sumaTotalEstimadoAnterior: this.sumaTotalEstimadoAnteriror.importe,
        sumaTotalEstimadoActual: this.sumaTotalEstimadoActual.importe,
        sumaTotalAcumulado: this.sumaTotalEstimadoAnteriror.importe
                            + this.sumaTotalEstimadoActual.importe,
      };
      let partidas = this.getPartidas;
      const partidasSubtotal = partidas.map((partida) => {
        const subtotalImporteContratado = this.sumaImporteContratado(partida.conceptosEstimados);
        const subtotalImporteEstimadoAnterior =
        this.$ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior');
        const subtotalImporte = this.$ObjSumar(partida.conceptosEstimados, 'importe');
        const subtotalImporteAcumulado =
        this.$ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior')
                    + this.$ObjSumar(partida.conceptosEstimados, 'importe');
        return {
          partida,
          subtotalImporteContratado,
          subtotalImporteEstimadoAnterior,
          subtotalImporte,
          subtotalImporteAcumulado,
        };
      });

      partidas = this.formatoObjeto(partidasSubtotal);
      estimacion = this.formatoObjeto(estimacion);
      contrato = this.formatoObjeto(contrato);
      const supervisor = this.getSupervisor || '';
      const supervisionExterna = this.getContratoSupervisionExterna?.contratoRelacionado
        ?.contratista?.nombreRazonSocial || '';
      const firmasFuncionarios = this.firmas;
      const fechaActual = this.formatoFechaActual();
      totales = this.formatoObjeto(totales);

      const nombreTemplate = 'templateRelacionConceptos';

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato,
          estimacion,
          partidas,
          supervisor,
          supervisionExterna,
          firmas: firmasFuncionarios,
          fechaActual,
          totales,
          footer: '',
        },
      }, `${this.contrato.numero}_RelacionConceptos_Estimacion_${this.estimacion.numero}`);
      this.$emit('terminando');
    },
  },
  computed: {
    getPartidas() {
      // Formato de conceptos
      const partidas = this.estimacion.conceptos
        .map(({ concepto: { padre }, concepto }) => {
          let partida = null;
          if (padre.padre && padre.padre.tipo === 0) {
            partida = padre.padre;
          }
          return {
            id: padre.id,
            clave: padre.clave.slice(0, 15),
            concepto: padre.concepto,
            orden: concepto.orden,
            padre: partida,
            tipo: padre.tipo,
            conceptosEstimados: [],
          };
        });

      // Remover conceptos repetidos
      const partidasUnicas = [...new Map(partidas.map((v) => [v.id, v])).values()];

      return partidasUnicas.map((partida) => {
        const conceptos = this.estimacion.conceptos
          .filter(({ concepto: { padre } }) => padre.id === partida.id)
          .map((concepto) => {
            const { estimado } = concepto.concepto;
            const estimadoAnterior = estimado
              .map((con) => ({
                numero: con.estimacion.numero,
                cantidad: con.cantidad,
                importe: con.importe,
              }))
              .filter(({ numero }) => numero < this.estimacion.numero);

            return {
              ...concepto,
              cantidadEstimadaAnterior: this.$ObjSumar(estimadoAnterior, 'cantidad'),
              importeEstimadoAnterior: this.$ObjSumar(estimadoAnterior, 'importe'),
              cantidadEstimadaAcumulada:
              this.$ObjSumar(estimadoAnterior, 'cantidad') + concepto.cantidad,
              importeEstimadoAcumulado:
              this.$ObjSumar(estimadoAnterior, 'importe') + concepto.importe,
            };
          })
          .sort((a, b) => a.concepto.orden - b.concepto.orden);

        return {
          ...partida,
          conceptosEstimados: conceptos,
        };
      })
        .sort((a, b) => a.orden - b.orden);
    },
    sumaTotalContratado() {
      const suma = [];
      if (this.getPartidas.length <= 0) return {};

      this.getPartidas.forEach((partida) => {
        const estimado = partida.conceptosEstimados;
        const importes = estimado.map((est) => ({
          importe: est.concepto.importe,
        }));

        suma.push({
          importe: this.$ObjSumar(importes, 'importe'),
        });
      });

      const importe = this.$ObjSumar(suma, 'importe');
      const iva = this.$numberRound((importe * (this.contrato.porcetajeIva)));
      const total = this.$numberRound((importe + iva));

      return {
        importe,
        iva,
        total,
      };
    },
    sumaTotalEstimadoAnteriror() {
      const suma = [];
      if (this.getPartidas.length <= 0) return {};

      this.getPartidas.forEach((partida) => {
        suma.push({
          importe: this.$ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior'),
        });
      });

      const importe = this.$ObjSumar(suma, 'importe');
      const iva = this.$numberRound((importe * (this.contrato.porcetajeIva)));
      const total = this.$numberRound((importe + iva));

      return {
        importe,
        iva,
        total,
      };
    },
    sumaTotalEstimadoActual() {
      const suma = [];
      if (this.getPartidas.length <= 0) return {};

      this.getPartidas.forEach((partida) => {
        suma.push({
          importe: this.$ObjSumar(partida.conceptosEstimados, 'importe'),
        });
      });

      const importe = this.$ObjSumar(suma, 'importe');
      const iva = this.$numberRound((importe * (this.contrato.porcetajeIva)));
      const total = this.$numberRound((importe + iva));

      return {
        importe,
        iva,
        total,
      };
    },
    getSupervisor() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    getContratoSupervisionExterna() {
      return this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
  }, */
};
</script>

<style lang="scss" scoped>
@media print {
  @page {
    size: landscape;
    margin: 0;
  }
  .imprimir-tabla {
    font-size: 8px !important;
    border:10px solid #000 !important;
  }
}
body {
    margin:0;
    padding:0;
}
</style>
